<template>
  <div class="footer">
    <div class="footer-container">
      <div class="footer-logo-container" @click="toHome">
        <img class="footer-logo" src="../assets/xlh_logo.png" />
      </div>
      <div class="footer-content-title">
        <!--<div class="footer-title">我们的服务</div>-->
        <div class="footer-title" @click="toHome($event)">首页</div>
        <div class="footer-title" @click="toAboutUs($event)">关于我们</div>
        <div class="footer-title" @click="toArticle($event)">动态</div>
        <div class="footer-title" @click="toVideo($event)">视频</div>
        <div class="footer-title" @click="toContactUs($event)">联系我们</div>
        <div class="clearboth"></div>
      </div>
      <div class="footer-content-title">
        <div class="footer-title footer-friendship-link-txt">友情链接</div>
        <div class="footer-title" @click="toHfwb($event)">汇丰企业外包</div>
        <div class="footer-title" @click="toHf($event)">汇丰派遣</div>
      </div>
      <div class="footer-content-info">
        <div class="footer-info">
          公司地址：天津空港经济区西七道1号凤凰墅69号楼
        </div>
        <div class="footer-info">电子邮箱：info@huifeng1997.cn</div>
      </div>
      <div class="footer-line"></div>
      <div class="footer-copyright">
        版权所有&nbsp;&nbsp;薪领航（天津）管理咨询有限公司&nbsp;&nbsp;<span style="cursor: pointer" @click="toBeian">津ICP备14002156号-2</span><br>
        薪领航对各类型企业标准化管理,企业内部风险管理,规章制度编写，员工关系管理,员工素质提升,劳动关系管理等服务有着非常丰富的经验,欢迎咨询。
      </div>

      <div class="footer-contact-container">
        <div class="footer-contact-content">
          <div class="footer-contact">
            <div class="footer-phone-type"></div>
            <div class="footer-phone"></div>
          </div>
          <div class="footer-contact">
            <div class="footer-phone-type">已合作客户</div>
            <div class="footer-phone">022-84476135</div>
          </div>
        </div>
        <div class="footer-contact-code">
          <img class="footer-code" src="../assets/qrcode.jpg" />
        </div>
        <div class="clearboth"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      time: 0,
    };
  },
  created(){
    setInterval(()=>{
      this.time = this.time + 1
    },1000);

    let excludes = {};
    let options = {
      excludes: excludes
    }
    //console.log(options)
    Fingerprint2.get(options, function(components) {
      // 参数
      const values = components.map(function(component) {
        return component.value
      });
      // 指纹
      const murmur = Fingerprint2.x64hash128(values.join(''), 31);
      // view.innerHTML += '<p class="pp">标识 : ' + murmur + '</p>';
      sessionStorage.setItem("Finger", murmur); //存入标识值
      //console.log(murmur);
    });
  },
  methods: {
    toHome(e) {
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.toVisitPage(this.$route.path,'/',0,0,x,y)
      this.$router.push('/');
    },
    toAboutUs(e) {
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.toVisitPage(this.$route.path,'/aboutUs',0,0,x,y)
      this.$router.push('/aboutUs');
    },
    toContactUs(e) {
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.toVisitPage(this.$route.path,'/contactUs',0,0,x,y)
      this.$router.push('/contactUs');
    },
    toArticle(e){
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.toVisitPage(this.$route.path,'/article',0,0,x,y)
      this.$router.push('/article');
    },
    toVideo(e){
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.toVisitPage(this.$route.path,'/video',0,0,x,y)
      this.$router.push('/video');
    },
    toHfwb(e){
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      window.location.href = "http://www.hfwb1997.com/";
      this.toVisitPage(this.$route.path,'hfwb1997',0,0,x,y)
    },
    toHf(e){
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      window.location.href = "http://www.hf1997.com/";
      this.toVisitPage(this.$route.path,'hf1997',0,0,x,y)
    },
    toVisitPage(fromPagePath,toPagePath,buttonId,resourceId,coordinateX,coordinateY){
      let params = {};
      let fromPage = 0
      let toPage = 0
      //页面1首页2关于我们3动态4视频5联系我们6获取报价
      //按钮1免费上门评估2上门评估预约3获取报价提交
      if(fromPagePath=='/'){
          fromPage = 1
        }else if(fromPagePath=='/aboutUs'){
          fromPage = 2
        }else if(fromPagePath=='/article'){
          fromPage = 3
        }else if(fromPagePath=='/video'){
          fromPage = 4
        }else if(fromPagePath=='/contactUs'){
          fromPage = 5
        }else if(fromPagePath=='/quotation'){
          fromPage = 6
        }else if(fromPagePath=='/articleInfo'){
          fromPage = 10
        }else if(fromPagePath=='/videoInfo'){
          fromPage = 11
        }
        if(toPagePath=='/'){
          toPage = 1
        }else if(toPagePath=='/aboutUs'){
          toPage = 2
        }else if(toPagePath=='/article'){
          toPage = 3
        }else if(toPagePath=='/video'){
          toPage = 4
        }else if(toPagePath=='/contactUs'){
          toPage = 5
        }else if(toPagePath=='/quotation'){
          toPage = 6
        }else if(toPagePath=='saas'){
          toPage = 7
        }else if(toPagePath=='hfwb1997'){
          toPage = 8
        }else if(toPagePath=='hf1997'){
          toPage = 9
        }else if(toPagePath=='/articleInfo'){
          toPage = 10
        }else if(toPagePath=='/videoInfo'){
          toPage = 11
        }

      if(buttonId==null){
        buttonId = 0
      }
      if(resourceId==null){
        resourceId = 0
      }
      if(coordinateX==null){
        coordinateX = 0
      }
      if(coordinateY==null){
        coordinateY = 0
      }
      params.fromPage = fromPage;
      params.toPage = toPage;
      params.button = buttonId;
      params.resourceId = resourceId;
      params.coordinateX = coordinateX;
      params.coordinateY = coordinateY;
      params.time = this.time;
      params.sessionId = sessionStorage.getItem("Finger");//浏览器标识
      axios
      .post("pilotage/webVisit", params)
      .then((res) => {
      })
      .catch((res) => {});
    },
    toBeian(){
      window.open("https://beian.miit.gov.cn/");
    }
  },
};
</script>

<style scoped>
.clearboth {
  clear: both;
}
.footer {
  background-color: #00368a;
}
.footer-container {
  width: calc(100% - 160px);
  margin: auto;
  position: relative;
  padding: 35px 0 34px 0;
}
.footer-logo-container {
  cursor: pointer;
  display: inline;
}
.footer-logo {
  height: 42px;
  width: auto;
}
.footer-content-title {
  margin-top: 21px;
}
.footer-title {
  color: #ffffff;
  float: left;
  margin-left: 30px;
  font-size: 16px;
  line-height: 24px;
  font-family: Noto Sans SC;
  cursor: pointer;
}
.footer-title:first-child {
  margin-left: 0px;
  /*cursor: auto;*/
}
.footer-friendship-link-txt{
  cursor: auto;
}
.footer-content-info {
  margin-top: 78px;
}
.footer-info {
  color: #ffffff;
  margin-top: 14px;
  font-size: 14px;
  line-height: 20px;
  font-family: Noto Sans SC;
}
.footer-info:first-child {
  margin-top: 0px;
}
.footer-line {
  margin-top: 27px;
  width: 100%;
  background: rgba(255, 255, 255, 0.3);
  height: 0.5px;
}
.footer-copyright {
  color: #ffffff;
  margin-top: 11px;
  font-size: 12px;
  line-height: 14px;
  font-family: Noto Sans SC;
  transform: scale(0.833333);
  transform-origin: left;
}

.footer-contact-container {
  position: absolute;
  bottom: 87px;
  right: 0;
}
.footer-contact-content {
  float: left;
}
.footer-contact {
  margin-top: 13px;
}
.footer-contact:first-child {
  margin-top: 0px;
}
.footer-phone-type {
  font-family: Noto Sans SC;
  font-size: 12px;
  line-height: 18px;
  color: #ffffff;
  font-weight: 500;
}
.footer-phone {
  font-family: Noto Sans SC;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
  font-weight: 500;
}
.footer-contact-code {
  width: 59px;
  height: 59px;
  float: left;
  margin-left: 32px;
  margin-top: 40px;
}

.footer-code {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue